module.exports = __webpack_public_path__ + "static/media/countries.d531b6ed.csv";